export const visit = (vm, at) => {
at({ "pt-br": { "conversationsVisitorUIPageTitleNotifications": { "newMessage": "Nova mensagem" } } });
};